import { LiveKitRoom } from '@livekit/components-react';
import '@livekit/components-styles';
import SharedBackground from './components/SharedBackground';
import EnhancedVideoConference from './components/EnhancedVideoConference';
import { useEffect, useState, useRef } from 'react';
const USE_PROMPT = false;

// Extract room name from URL or use a default
const pathSegments = window.location.pathname.split('/');
const roomName = pathSegments.length > 1 && pathSegments[1] !== '' ? pathSegments[1] : 'default-room';

// Identity and access key extraction and validation
const initialIdentity = pathSegments[2];
const providedKey = pathSegments[3];

// Simple base64 hash function with secret salt
function encodeName(name) {
  try {
    const secret = 'applebanana';
    return btoa(`${name}:${secret}`).slice(0, 12);
  } catch {
    return '';
  }
}

const expectedKey = encodeName(initialIdentity);

// Skip key check for admin-keygen room
if (roomName !== 'admin-keygen' && providedKey !== expectedKey) {
//  if (providedKey !== expectedKey) {
  alert("This link appears invalid or was not generated for you.");
  throw new Error("Invalid access key.");
}

export default function App() {
  const [token, setToken] = useState(null);
  const [url, setUrl] = useState(null);
  const [identity, setIdentity] = useState(initialIdentity);
  const hasPromptedRef = useRef(false);

  // Prompt user for identity based on room name
  
  useEffect(() => {
    if (!USE_PROMPT) return;
    if (hasPromptedRef.current) return;
    hasPromptedRef.current = true;
    const parts = roomName.split('_');
    if (parts.length >= 3) {
      const inviter = parts[0];
      const invitee = parts[1];
      const userIdentity = window.confirm(`Hi, welcome. ${inviter} set up this room for an event. Are you ${invitee}? Click Cancel if you are .`)
        ? invitee
        : inviter;
      setIdentity(userIdentity);
    } else {
      setIdentity('guest');
    }
  }, []);


  useEffect(() => {
    if (!identity) return;
    console.log(`Fetching token for room: ${roomName} as ${identity}`);
    const backendUrl = import.meta.env.VITE_BACKEND_URL || 'http://localhost:3101';
    fetch(`${backendUrl}/api/token/${roomName}?identity=${identity}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Server responded with status: ${res.status}`);
        }
        return res.json();
      })
      .then(({ token, livekitUrl }) => {
        console.log('Token received successfully');
        setToken(token);
        setUrl(livekitUrl);
      })
      .catch((error) => {
        console.error('Error fetching token:', error);
      });
  }, [identity]);

if (!token || !url) {
  // Special admin-keygen bypass
  if (roomName === 'admin-keygen') {
    const [roomInput, setRoomInput] = useState('');
    const [nameInput, setNameInput] = useState('');
    const [generatedLink, setGeneratedLink] = useState('');

    const generate = () => {
      const key = encodeName(nameInput);
      const url = `${window.location.origin}/${roomInput}/${nameInput}/${key}`;
      setGeneratedLink(url);
    };

    return (
      <div style={{ padding: '2rem', maxWidth: '500px', margin: '0 auto' }}>
        <h2>Key Generator</h2>
        <div style={{ marginBottom: '1rem' }}>
          <label>Room: <input value={roomInput} onChange={(e) => setRoomInput(e.target.value)} /></label>
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label>Name: <input value={nameInput} onChange={(e) => setNameInput(e.target.value)} /></label>
        </div>
        <button onClick={generate}>Generate Link</button>
        {generatedLink && (
          <div style={{ marginTop: '1rem' }}>
            <strong>Generated Link:</strong>
            <div style={{ wordBreak: 'break-all' }}>{generatedLink}</div>
          </div>
        )}
      </div>
    );
  }
  return <div>Loading...</div>;
}

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ padding: '1rem', backgroundColor: '#f0f0f0', borderBottom: '1px solid #ddd' }}>
        <h1 style={{ margin: 0 }}>Room: {roomName}</h1>
      </div>
      
      <div style={{ position: 'relative', flex: 1, overflow: 'hidden' }}>
        <LiveKitRoom 
          token={token} 
          serverUrl={url} 
          connect 
          video 
          audio
          style={{ height: '100%', width: '100%', position: 'relative' }}
          data={{ enabled: true }}
        >
          {/* Shared background layer */}
          <SharedBackground roomName={roomName} />
          
          {/* Video conference layer with integrated controls and chat */}
          <EnhancedVideoConference roomName={roomName} userIdentity={identity} />
        </LiveKitRoom>
      </div>
    </div>
  );
}